export const nav = {
  accounts: "用户列表",
  allRightsReserved: "版权所有",
  billingAndPayment: "账单和支付",
  billingRecord: "@:payment.billingRecords",
  changePassword: "修改密码",
  copyrightYearVIATechnologiesInc: "本网站由 威盛电子股份有限公司 提供技术支持",
  dashboard: "数字看板",
  drivers: "司机档案",
  geofence: "电子围栏设置",
  history: "历史作业",
  inspection: "点检模板",
  inspectionReports: "点检报告",
  liveTracking: "实时状态",
  logout: "登出",
  logoutAndReturnToTheLoginPage: "登出，并重新登录？",
  management: "设备管理",
  models: "设备型号",
  monitor: "设备监控",
  roles: "角色权限",
  settings: "管理设置",
  support: "技术支持",
  system: "AI主机设置",
  timezoneUTC: "时区：UTC{val}",
  updateAccountInformation: "更新账号信息",
  uploadedVideos: "已采集视频",
  users: "账号管理",
  vehicles: "设备列表",
  VIAMobile360WorkXConnect: "VIA Mobile360 CWorkX Connect",
  workXConnect: "桥式起重机安全监控管理平台",
  maintenanceTemplate: "保养模板",
  maintenanceRepair: "设备维保",
  maintenance: "保养单列表",
  repair: "维修单列表",
  remind: "提醒设置",
  organization: "组织架构",
  log: "操作日志",
  schedule: "排班",
  reportDownload: "报表下载",
  greetingSetting: "设备开机问候语",
  eventLevel: "消息设置",
  regionalSpeedLimit: "分区限速设置",
  healthReport: "AI主机异常",
  report: "统计分析",
  alert: "事件信息",
  driverManagement: "司机管理",
  vehicleStatisticReport: "设备使用效率报表",
  driverStatisticReport: "司机工作统计报表",
};
